import { debug } from 'zf-web-infra';
import type { ReactNode, ReactElement } from 'react';
import type { ColumnProps } from 'antd/es/table';
import type { NoProps } from '../types';

export function No<T>(props: NoProps<T>): ReactElement | null {
  debug.common('No', props);
  return null;
}

/**
 * 需要设置 displayName，否则无法通过 type.displayName 获取到组件名称
 * 元本是通过 name 来获取的，但是 name 在生产环境会被压缩，所以改为 displayName
 */
No.displayName = 'No';

/**
 * 默认居中，标题默认叫 "No."
 * @param child
 * @returns
 */
export function getNoProps<T>(child: ReactElement<ColumnProps<T>>): ColumnProps<T> {
  return {
    render: (text, record, index): ReactNode => index + 1,
    key: 'no',
    title: 'No.',
    align: 'center',
    width: child.props.width ?? 100,
    ...child.props
  };
}

